// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeader_root__eTbdH","title":"PageHeader_title__K0r1d","subtitle":"PageHeader_subtitle__VCyyD","tags":"PageHeader_tags__P7vOy","tag":"PageHeader_tag__ONNAK"};